/**
 * Provede aktualizaci query parametru v adrese.
 * @param {string} uri - Upravovaná adresa
 * @param {string} key - Klíč parametru
 * @param {string} value - Hodnota parametru
 * @returns {string} upravená adresa
 */
export function updateQueryStringParameter(
  uri: string,
  key: string,
  value?: string
): string {
  if (value === null || value === undefined) {
    return uri;
  }

  const upValue = encodeURIComponent(value);

  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + upValue + '$2');
  } else {
    return uri + separator + key + '=' + upValue;
  }
}

/**
 * Provede aktualizaci všech query parametrů v adrese.
 *
 * @param {string} uri - Upravovaná adresa
 * @param {Object} params - Object query parametrů -> klíč: hodnota
 * @param appendTimestamp pokud je true, přidá se časová značka do url jako parametr _t
 * @returns {string} upravená adresa
 */
export function generateUrl(
  uri: string,
  params: { [key in string | number]: any },
  appendTimestamp = false
): string {
  let useParams: { [key in string | number]: any } | undefined;
  if (params || appendTimestamp) {
    let timeParams = appendTimestamp ? { _t: new Date().getTime() } : {};
    useParams = params ? { ...params, ...timeParams } : timeParams;
  }

  if (useParams) {
    for (let key in useParams) {
      const value = useParams[key];
      uri = updateQueryStringParameter(uri, key, value);
    }
  }
  return uri;
}
